import logger from "@airhelp/node-logger";
import type { Currencies } from "config/currencies";
import { formatCurrency } from "config/currencies";
import type { LanguageCode } from "config/languages";
import get from "lodash.get";
import { useRouter } from "next/router";
import { useCallback, useContext } from "react";
import { LocalizationContext } from "./LocalizationContext";

export const useLanguage = () => get(useContext(LocalizationContext), "language", "") as LanguageCode;

export const useTranslations = () => {
  const translations = get(useContext(LocalizationContext), ["translations"], "");
  const { asPath } = useRouter();

  return (key: string, args?) => {
    let translation = get(translations, key, key);

    if (typeof args !== "undefined") {
      Object.keys(args).forEach((k) => {
        const reg = new RegExp(k, "g");
        translation = translation.replace(reg, args[k]);
      });
    }

    if (translation === key) {
      logger.info(`KEY: "${key}" - does not exist in the page namespaces, route: ${asPath}`);
    }
    return translation;
  };
};

export const useLocalizedData = () => {
  const language = useLanguage();

  const getLocalizedNumber = useCallback(
    (value: number) => {
      const locale = language === "en-int" ? "en-us" : language;

      return new Intl.NumberFormat(locale).format(value);
    },
    [language]
  );

  const getLocalizedCurrency = useCallback(
    (value: number, fixedCurrency?: Currencies, precision?: number) =>
      formatCurrency(value, language, fixedCurrency, precision),
    [language]
  );

  return { getLocalizedNumber, getLocalizedCurrency };
};
